import {
  cropinkUIResources,
  CROPINK_UI_I18N_NAMESPACE,
} from '@cropink/ui-components';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import resources from './resources';

const supportedLngs = ['en'];

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    defaultNS: 'common',
    // The UI kit ships its own strings in a separate namespace. Anything
    // defined in `common` wins, so overriding one of them only takes
    // repeating that key here.
    fallbackNS: CROPINK_UI_I18N_NAMESPACE,
    ns: [...Object.keys(resources), CROPINK_UI_I18N_NAMESPACE],
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    supportedLngs,
    resources: { en: { ...resources, ...cropinkUIResources.en } },
    showSupportNotice: false,
  });

export default i18n;
